export default __webpack_public_path__ + "assets/5cf19d21b4c0b3671293e392a44a8b86.png";